var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsThinkboxStoke32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-ThinkBox-Stoke_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-ThinkBox-Stoke_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-ThinkBox-Stoke_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,14.12725 C27.459,12.35925 26.697,10.54225 25.709,8.65725 L28,9.80225 L28,14.12725 Z M16.359,18.64625 C16.172,18.45125 15.828,18.45125 15.641,18.64625 C15.499,18.79225 12.176,22.26925 12.176,25.90625 C12.176,26.39725 12.266,26.93625 12.427,27.46225 C11.521,26.45925 11,25.07325 11,23.49325 C11,18.44325 14.779,13.30625 16,11.77825 C17.221,13.30625 21,18.44325 21,23.49325 C21,25.07325 20.479,26.45925 19.573,27.46225 C19.734,26.93625 19.824,26.39725 19.824,25.90625 C19.824,22.26925 16.501,18.79225 16.359,18.64625 L16.359,18.64625 Z M16,3.23225 C17.602,5.01825 24,12.62525 24,20.17125 C24,22.41725 23.081,24.52325 21.559,26.04725 C21.841,25.26525 22,24.40725 22,23.49325 C22,17.11925 16.604,10.92325 16.375,10.66325 C16.186,10.44725 15.814,10.44725 15.625,10.66325 C15.396,10.92325 10,17.11925 10,23.49325 C10,24.40825 10.159,25.26525 10.441,26.04725 C8.919,24.52325 8,22.41725 8,20.17125 C8,12.62525 14.398,5.01825 16,3.23225 L16,3.23225 Z M4,9.80225 L6.291,8.65725 C5.303,10.54225 4.541,12.35925 4,14.12725 L4,9.80225 Z M17.716,29.94325 C17.724,29.94025 17.73,29.93425 17.738,29.93025 L17.739,29.93225 L28.739,23.93225 C28.9,23.84525 29,23.67625 29,23.49325 L29,9.49325 C29,9.30425 28.893,9.13125 28.724,9.04625 L24.724,7.04625 C24.526,6.94725 24.288,6.98925 24.137,7.15025 C23.985,7.31025 23.957,7.55125 24.066,7.74225 C26.713,12.35725 28,16.52825 28,20.49325 L28,23.19625 L23.005,25.92125 C24.262,24.31425 25,22.29725 25,20.17125 C25,11.18125 16.712,2.51025 16.359,2.14625 C16.172,1.95125 15.828,1.95125 15.641,2.14625 C15.288,2.51025 7,11.18125 7,20.17125 C7,22.29825 7.738,24.31425 8.996,25.92125 L4,23.19625 L4,20.49325 C4,16.52825 5.287,12.35725 7.934,7.74225 C8.043,7.55125 8.015,7.31025 7.863,7.15025 C7.712,6.98925 7.474,6.94725 7.276,7.04625 L3.276,9.04625 C3.107,9.13125 3,9.30425 3,9.49325 L3,23.49325 C3,23.67625 3.1,23.84525 3.261,23.93225 L14.261,29.93225 L14.262,29.93025 C14.27,29.93425 14.276,29.94025 14.284,29.94425 L14.739,29.05425 L14.705,29.03625 C13.761,28.57325 13.176,27.05525 13.176,25.90625 C13.176,23.33925 15.167,20.72625 16,19.74525 C16.833,20.72625 18.824,23.33925 18.824,25.90625 C18.824,27.05725 18.237,28.57825 17.29,29.03825 L17.261,29.05425 L17.716,29.94325 Z",
    id: "AWS-ThinkBox-Stoke_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsThinkboxStoke32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Thinkbox-Stoke_32.35f9d9e8f304efbcf4e6f85483f26473.svg";
export { ForwardRef as ReactComponent };